import React, { useEffect, useState } from "react";
import "./ProductReview.scss";
import { Icon } from "@iconify/react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { auth, firestoredb } from "../../../config";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import ProductReport from "./ProductReport";

function ProductReview() {
  const [showAnalysis, setShowAnalysis] = useState("");
  const [ourBrand, setOurBrand] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false)
  const [done, setDone] = useState(false);
  const user = auth.currentUser
  const handleInputChangeOurBrand = (e) => {
    setOurBrand((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleShowComparing = () => {
    setShowAnalysis(true);
  };
  const startComparing = async () => {
    try {
      setLoading(true);

      // const resultOwnBrand = await axios.post(
      //   process.env.REACT_APP_SERVER_URL + "/singleProductAnalysis",
      //   { domain: ourBrand.productName }
      // );
      const resultOwnBrand = await axios.post(
        process.env.REACT_APP_SERVER_URL + "/singleProductAnalysisNew",
        { domain: ourBrand.productName }
      );
      // const resultOwnBrand = await axios.post(
      //   "http://localhost:8080/singleProductAnalysis",
      //   { domain: ourBrand.productName }
      // );
      if (resultOwnBrand.data.message) {
        setError(true);
        setShowAnalysis(false);
        setLoading(false);

      }
      else {

        setOurBrand((prev) => ({
          ...prev,
          productAnalysis: resultOwnBrand.data,
        }));
        setDone(true)
        setLoading(false);
      }
    } catch {
      setLoading(false);

      alert("Error");
    }
  };

  const handleDbSave = async () => {
    try {
      //fetching previous data first
      if (user) {
        // // console.log("Fetching Data from DB");
        const docRef = doc(firestoredb, "users", user.uid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          // // console.log("Document data gs:", docSnap.data());
          if (docSnap.data().productAnalysis) {

            let productAnalysis = docSnap.data().productAnalysis;
            let tempData = ourBrand;
            tempData.productAnalysis.productReview = {}
            console.log("what's saving", tempData);
            await updateDoc(docRef, {
              productAnalysis: [
                ...productAnalysis,
                {
                  ...tempData
                }
              ],
            });
            console.log("Data Successfully save to Database");
          }
          else {
            let tempData = ourBrand;
            tempData.productAnalysis.productReview = {}
            console.log("what's saving", tempData);

            await updateDoc(docRef, {
              productAnalysis: [
                {
                  ...tempData
                }
              ],
            });
            console.log("Data Successfully save to Database");
          }
        }
      }
    }
    catch (error) {
      console.log("Error while saving to Database");
      console.log(error);
    }
  }
  useEffect(() => {
    if (done) {

      handleDbSave();
    }
  }, [done])

  useEffect(() => {
    console.log("Our Brand", ourBrand);
  }, [ourBrand]);
  return (
    <>
      {showAnalysis ? (
        // <div className="Product-container customScroller-transparent">
        //   <div className="Product-inner-container">
        //     <h2>Analyze Product</h2>

        //     <div className="ProductCards">
        //       <div className="Product-Strenths-container">
        //         <div className="Strenths-cards-container">
        //           <h4>Product Information</h4>
        //           <div
        //             style={{
        //               display: "flex",
        //               gap: "10px",
        //               marginBottom: "20px",
        //             }}
        //             className="growth-cards"
        //           >
        //             <div className="dashboardMain-socialMediaStats-box widthPercentage">
        //               <h5>Growth Trend</h5>
        //               <ul>
        //                 <li>
        //                   <span>Trend</span>
        //                   <span>
        //                     {ourBrand.productAnalysis &&
        //                       ourBrand.productAnalysis.productInformation &&
        //                       ourBrand.productAnalysis.productInformation
        //                         .growthTrend}
        //                   </span>
        //                 </li>
        //                 <li>
        //                   <span>
        //                     {ourBrand.productAnalysis &&
        //                       ourBrand.productAnalysis.productInformation &&
        //                       ourBrand.productAnalysis.productInformation
        //                         .growthPercentage}
        //                   </span>
        //                 </li>
        //               </ul>
        //             </div>
        //             <div className="dashboardMain-socialMediaStats-box widthPercentage">
        //               <h5>Price</h5>
        //               <ul>
        //                 <li>
        //                   <span>
        //                     {" "}
        //                     {ourBrand.productAnalysis &&
        //                       ourBrand.productAnalysis.productInformation &&
        //                       ourBrand.productAnalysis.productInformation.price}
        //                   </span>
        //                 </li>

        //                 {/* <li>
        //                     <span>Followers</span>
        //                     <span>4702</span>
        //                   </li>
        //                   <li>
        //                     <span>Mentions</span>
        //                     <span>65</span>
        //                   </li> */}
        //               </ul>
        //             </div>

        //             <div className="dashboardMain-socialMediaStats-box widthPercentage">
        //               <h5>Sales Volume</h5>
        //               <ul>
        //                 <li>
        //                   <span>
        //                     {ourBrand.productAnalysis &&
        //                       ourBrand.productAnalysis.salesPerformance &&
        //                       ourBrand.productAnalysis.salesPerformance
        //                         .salesVolume}
        //                   </span>
        //                 </li>

        //                 {/* <li>
        //                     <span>Followers</span>
        //                     <span>4702</span>
        //                   </li>
        //                   <li>
        //                     <span>Mentions</span>
        //                     <span>65</span>
        //                   </li> */}
        //               </ul>
        //             </div>
        //           </div>
        //           <div className="cards gridTemplateOnlyOne" style={{ marginBottom: "10px" }}>
        //             <div className="strenth-card">
        //               <h3>Summary</h3>
        //               <ul>
        //                 <p>{ourBrand.productAnalysis &&
        //                   ourBrand.productAnalysis.summary ? ourBrand.productAnalysis.summary : "Summary couldn't be generated."}</p>
        //               </ul>
        //             </div>
        //           </div>
        //           <div className="cards gridTemplateOnlyOne">
        //             <div className="strenth-card">
        //               <h3>Features and Specifications</h3>
        //               <ul>
        //                 {ourBrand.productAnalysis &&
        //                   ourBrand.productAnalysis.FeaturesAndSpecifications &&
        //                   ourBrand.productAnalysis.FeaturesAndSpecifications.map(
        //                     (features) => (
        //                       <>
        //                         <h6>{features.heading}</h6>
        //                         <li>
        //                           <Icon
        //                             icon="solar:map-arrow-right-bold-duotone"
        //                             width="20"
        //                             height="20"
        //                           />
        //                           {features.details}
        //                         </li>
        //                       </>
        //                     )
        //                   )}
        //                 {/* <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Embrace ongoing education opportunities.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Enhance interpersonal and written skills.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Prioritize tasks for efficiency.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Cultivate professional relationships strategically.
        //                   </li>

        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Establish clear, achievable objectives.
        //                   </li> */}
        //               </ul>
        //             </div>
        //           </div>
        //         </div>
        //       </div>

        //       <div className="Product-Strenths-container2">
        //         <div className="Strenths-cards-container">
        //           <h4>Sentiment Analysis</h4>
        //           <div className="cards">

        //             <div className="strenth-card">
        //               <h3>Why Positive</h3>
        //               {ourBrand.productAnalysis &&
        //                 ourBrand.productAnalysis.whyPositiveReviews && ourBrand.productAnalysis.whyPositiveReviews.map((whyPositive) => (
        //                   <ul style={{ marginBottom: '15px', gap: "5px" }}>
        //                     {/* {ourBrand.salesPerformance && ourBrand.salesPerformance.salesVolume} */}
        //                     <h6>{whyPositive.heading}</h6>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {whyPositive.reasons}
        //                     </li>
        //                     {/* <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Adaptable to diverse tasks.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Detail-oriented and accurate.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Effective team player.
        //                   </li>

        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Endures challenges with fortitude.
        //                   </li> */}
        //                   </ul>
        //                 ))
        //               }

        //             </div>


        //             <div className="strenth-card">
        //               <h3>Why Neutral</h3>
        //               {ourBrand.productAnalysis &&
        //                 ourBrand.productAnalysis.whyNeutralReviews && ourBrand.productAnalysis.whyNeutralReviews.map((whyNeutral) => (
        //                   <ul style={{ marginBottom: '15px', gap: "5px" }}>
        //                     {/* {ourBrand.salesPerformance && ourBrand.salesPerformance.salesVolume} */}
        //                     <h6>{whyNeutral.heading}</h6>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {whyNeutral.reasons}
        //                     </li>
        //                     {/* <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Adaptable to diverse tasks.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Detail-oriented and accurate.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Effective team player.
        //                   </li>

        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Endures challenges with fortitude.
        //                   </li> */}
        //                   </ul>
        //                 ))
        //               }

        //             </div>
        //             <div className="strenth-card">
        //               <h3>Why Negative</h3>
        //               {ourBrand.productAnalysis &&
        //                 ourBrand.productAnalysis.whyNegativeReviews && ourBrand.productAnalysis.whyNegativeReviews.map((whyNegative) => (
        //                   <ul style={{ marginBottom: '15px', gap: "5px" }}>
        //                     {/* {ourBrand.salesPerformance && ourBrand.salesPerformance.salesVolume} */}
        //                     <h6>{whyNegative.heading}</h6>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {whyNegative.reasons}
        //                     </li>
        //                     {/* <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Adaptable to diverse tasks.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Detail-oriented and accurate.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Effective team player.
        //                   </li>

        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Endures challenges with fortitude.
        //                   </li> */}
        //                   </ul>
        //                 ))
        //               }

        //             </div>
        //           </div>
        //         </div>
        //       </div>

        //       <div className="Product-Strenths-container2">
        //         <div className="Strenths-cards-container">
        //           <h4>Sales Performance</h4>
        //           <div className="cards">

        //             <div className="strenth-card">
        //               <h3>Sales Volume</h3>
        //               <ul>
        //                 {/* {ourBrand.salesPerformance && ourBrand.salesPerformance.salesVolume} */}
        //                 <li>
        //                   <Icon
        //                     icon="solar:map-arrow-right-bold-duotone"
        //                     width="20"
        //                     height="20"
        //                   />
        //                   {ourBrand.productAnalysis &&
        //                     ourBrand.productAnalysis.salesPerformance &&
        //                     ourBrand.productAnalysis.salesPerformance
        //                       .salesVolume}
        //                 </li>
        //                 {/* <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Adaptable to diverse tasks.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Detail-oriented and accurate.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Effective team player.
        //                   </li>

        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Endures challenges with fortitude.
        //                   </li> */}
        //               </ul>
        //             </div>

        //             <div className="strenth-card">
        //               <h3>Market Share</h3>
        //               <ul>
        //                 {ourBrand.productAnalysis &&
        //                   ourBrand.productAnalysis.salesPerformance &&
        //                   ourBrand.productAnalysis.salesPerformance
        //                     .marketShare &&
        //                   ourBrand.productAnalysis.salesPerformance.marketShare.map(
        //                     (marketShare) => (
        //                       <li>
        //                         <Icon
        //                           icon="solar:map-arrow-right-bold-duotone"
        //                           width="20"
        //                           height="20"
        //                         />
        //                         {marketShare}
        //                       </li>
        //                     )
        //                   )}
        //                 {/* <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Delays completion of tasks.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Difficulty waiting for results.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Struggles with accepting imperfections.
        //                   </li>
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Reluctant to assign responsibilities.
        //                   </li>

        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     Nervousness in presenting publicly.
        //                   </li> */}
        //               </ul>
        //             </div>
        //           </div>
        //         </div>
        //       </div>

        //       <div className="Review-cards-container">
        //         <div className="Review-cards-box">
        //           <h5>Price And Value</h5>
        //           <ul>
        //             {ourBrand.productAnalysis &&
        //               ourBrand.productAnalysis.priceAndValue &&
        //               ourBrand.productAnalysis.priceAndValue.map(
        //                 (priceAndValue) => (
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     {priceAndValue}
        //                   </li>
        //                 )
        //               )}
        //             {/* <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Adaptable to diverse tasks.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Detail-oriented and accurate.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Effective team player.
        //               </li>

        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Endures challenges with fortitude.
        //               </li> */}
        //           </ul>
        //         </div>

        //         <div className="Review-cards-box">
        //           <h5>Competitive Analysis</h5>

        //           <ul>
        //             {ourBrand.productAnalysis &&
        //               ourBrand.productAnalysis.competitiveAnalysis &&
        //               ourBrand.productAnalysis.competitiveAnalysis.map(
        //                 (competitiveAnalysis) => (
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     {competitiveAnalysis}
        //                   </li>
        //                 )
        //               )}
        //             {/* <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Adaptable to diverse tasks.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Detail-oriented and accurate.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Effective team player.
        //               </li>

        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Endures challenges with fortitude.
        //               </li> */}
        //           </ul>
        //         </div>
        //       </div>

        //       {/* <div className="Review-cards-container">

        //     </div> */}

        //       <div className="Review-cards-container">
        //         <div className="Review-cards-box">
        //           <h5>Customer Reviews And FeedbackAnalysis</h5>
        //           <ul>
        //             {ourBrand.productAnalysis &&
        //               ourBrand.productAnalysis
        //                 .customerReviewsAndFeedbackAnalysis &&
        //               ourBrand.productAnalysis.customerReviewsAndFeedbackAnalysis.map(
        //                 (customerFeedback) => (
        //                   <li>
        //                     <Icon
        //                       icon="solar:map-arrow-right-bold-duotone"
        //                       width="20"
        //                       height="20"
        //                     />
        //                     {customerFeedback}
        //                   </li>
        //                 )
        //               )}
        //             {/* <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Adaptable to diverse tasks.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Detail-oriented and accurate.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Effective team player.
        //               </li>

        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Endures challenges with fortitude.
        //               </li> */}
        //           </ul>
        //         </div>

        //         <div className="Review-cards-box">
        //           <h5>Growth Rate</h5>
        //           <ul>
        //             <li>
        //               <Icon
        //                 icon="solar:map-arrow-right-bold-duotone"
        //                 width="20"
        //                 height="20"
        //               />
        //               {ourBrand.productAnalysis &&
        //                 ourBrand.productAnalysis.salesPerformance &&
        //                 ourBrand.productAnalysis.salesPerformance.growthRate}
        //             </li>
        //             {/* <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Adaptable to diverse tasks.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Detail-oriented and accurate.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Effective team player.
        //               </li>

        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Endures challenges with fortitude.
        //               </li> */}
        //           </ul>
        //         </div>
        //       </div>

        //       {/* <div className="Review-cards-container">

        //     </div> */}

        //       <div className="Review-cards-container">
        //         <div className="Review-cards-box">
        //           <h5>Customer Demographics</h5>
        //           <ul>
        //             {ourBrand.productAnalysis &&
        //               ourBrand.productAnalysis.salesPerformance &&
        //               ourBrand.productAnalysis.salesPerformance
        //                 .customerDemographics &&
        //               ourBrand.productAnalysis.salesPerformance.customerDemographics.map(
        //                 (customerDemographical) => (
        //                   <>
        //                     <h6>{customerDemographical.regionName}</h6>
        //                     <li>
        //                       <Icon
        //                         icon="solar:map-arrow-right-bold-duotone"
        //                         width="20"
        //                         height="20"
        //                       />
        //                       {"Around " + customerDemographical.customerNumber + " at " + customerDemographical.regionName}
        //                     </li>
        //                   </>
        //                 )
        //               )}
        //             {/* <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Adaptable to diverse tasks.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Detail-oriented and accurate.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Effective team player.
        //               </li>

        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Endures challenges with fortitude.
        //               </li> */}
        //           </ul>
        //         </div>

        //         <div className="Review-cards-box">
        //           <h5>References</h5>
        //           <ul>
        //             {ourBrand.productAnalysis &&
        //               ourBrand.productAnalysis.references &&
        //               ourBrand.productAnalysis.references.map((reference) => (
        //                 <li>
        //                   <Icon
        //                     icon="solar:map-arrow-right-bold-duotone"
        //                     width="20"
        //                     height="20"
        //                   />
        //                   {reference}
        //                 </li>
        //               ))}
        //             {/* <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Innovative problem-solving approach.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Adaptable to diverse tasks.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Detail-oriented and accurate.
        //               </li>
        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Effective team player.
        //               </li>

        //               <li>
        //                 <Icon
        //                   icon="solar:map-arrow-right-bold-duotone"
        //                   width="20"
        //                   height="20"
        //                 />
        //                 Endures challenges with fortitude.
        //               </li> */}
        //           </ul>
        //         </div>
        //       </div>

        //       <div className="Review-container ">
        //         <h3>Reviews</h3>
        //         <div
        //           className="Review-cards-container"
        //           style={{ overflowX: "auto" }}
        //         >
        //           {ourBrand.productAnalysis &&
        //             ourBrand.productAnalysis.productReview && ourBrand.productAnalysis.productReview.reviews && ourBrand.productAnalysis.productReview.reviews.map((reviews, i) => (
        //               reviews.reviewComments ?
        //                 <div className="Review-cards-box">
        //                   <h5>{reviews.reviewAuthorName}</h5>
        //                   <h6>{reviews.reviewTitle}</h6>
        //                   <div className="flexQuotes">
        //                     {/* <Icon
        //                 icon="ci:double-quotes-l"
        //                 className="qoutes-symbol1"
        //               /> */}
        //                     <p>{reviews.reviewComments}</p>
        //                     {/* <Icon
        //                 icon="ci:double-quotes-r"
        //                 className="qoutes-symbol2"
        //               /> */}
        //                   </div>
        //                 </div>
        //                 :
        //                 ""
        //             ))}
        //           {/* <div className="Review-cards-box">
        //         <h5>La Lisa</h5>
        //         <h6>TERRIBLE customer support</h6>
        //         <div className="flexQuotes">
        //           <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
        //           <p>
        //             TERRIBLE customer support. Not even giving them every single
        //             piece of proof (even your old credit card info where all the
        //             purchases are attached) about a stolen account being yours makes
        //             them realize it's yours and WILL allow hackers to keep stolen
        //             accounts by not checking any proof. Now, they will gladly ban
        //             you by IP yet they cannot check the IP when it comes to
        //             thievery. If I were you, I would just limit myself to Steam.
        //           </p>
        //           <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
        //         </div>
        //       </div>
        //       <div className="Review-cards-box">
        //         <h5>Devil Jennie</h5>
        //         <h6>TERRIBLE customer support</h6>
        //         <div className="flexQuotes">
        //           <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
        //           <p>
        //             TERRIBLE customer support. Not even giving them every single
        //             piece of proof (even your old credit card info where all the
        //             purchases are attached) about a stolen account being yours makes
        //             them realize it's yours and WILL allow hackers to keep stolen
        //             accounts by not checking any proof. Now, they will gladly ban
        //             you by IP yet they cannot check the IP when it comes to
        //             thievery. If I were you, I would just limit myself to Steam.
        //           </p>
        //           <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
        //         </div>
        //       </div>
        //       <div className="Review-cards-box">
        //         <h5>Devil Jennie</h5>
        //         <h6>TERRIBLE customer support</h6>
        //         <div className="flexQuotes">
        //           <Icon icon="ci:double-quotes-l" className="qoutes-symbol1" />
        //           <p>
        //             TERRIBLE customer support. Not even giving them every single
        //             piece of proof (even your old credit card info where all the
        //             purchases are attached) about a stolen account being yours makes
        //             them realize it's yours and WILL allow hackers to keep stolen
        //             accounts by not checking any proof. Now, they will gladly ban
        //             you by IP yet they cannot check the IP when it comes to
        //             thievery. If I were you, I would just limit myself to Steam.
        //           </p>
        //           <Icon icon="ci:double-quotes-r" className="qoutes-symbol2" />
        //         </div>
        //       </div> */}
        //         </div>
        //       </div>
        //     </div>
        //   </div>
        // </div>
        <ProductReport ourBrand={ourBrand}></ProductReport>
      ) : (
        <div
          className="BrandComparison-container customScroller-transparent"
          style={{ width: "100%" }}
        >
          <h3>Analyze your product</h3>
          <div className="BrandComparison-socialMediaStats-container gridTemplateOnlyOne">
            <div className="BrandComparison-socialMediaStats-box">
              <h5>Analyze Product</h5>
              <div className="brand_inputs-box">
                <h6>Product Name</h6>
                <input
                  className="input-theme"
                  type="text"
                  placeholder="Product Name"
                  name="productName"
                  onChange={handleInputChangeOurBrand}
                />
              </div>

              <button
                className="dark-theme-btn"
                onClick={() => {
                  startComparing();
                  handleShowComparing();
                }}
              >
                Start Analyzing
              </button>
            </div>
          </div>
        </div>
      )}
      <Modal show={loading} centered>
        <Modal.Header>
          <Modal.Title>Loading... Please wait</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div class="lds-ringDashboard">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal show={error} centered onHide={() => setError(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Opss...</Modal.Title>
          {/* <button onClick={() => setLoading(false)}></button> */}
        </Modal.Header>

        <Modal.Body>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "30%",
            }}
          >
            <p className="modal-p">Doesn't seem like a valid product!</p>

          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ProductReview;
